import React, { useMemo } from 'react'

import { TestData as AnimalData } from '../../Assets/TestData/animalData';
import { AnimalGroupData as GroupData } from '../../Assets/TestData/animalGroups';
import { colors, fonts, glyphs, useMediaQuery } from '../../Styles';
import { useTranslation } from 'react-i18next';

interface groupCard_Props {
  selectedGroupId: number
}

export default function GroupCard({selectedGroupId}:groupCard_Props) {
  const { t } = useTranslation();
  // #region | Data

  // Animal group
  const groupData = useMemo(() => {
    return GroupData.find(group => group.groupId === selectedGroupId);
  }, [selectedGroupId]);

  const groupAmount = useMemo(() => {
    return AnimalData.filter(animal => animal.groupId === selectedGroupId).length
  }, [selectedGroupId])

  if (!groupData) return null
  const groupName = groupData.groupName
  
  // #endregion

  return ( <>
    <div style={{
      borderRadius: "10px",
      height: "fit-content",
      overflow: "hidden",
      border: "5px solid"+colors.greyPrimary, 
      minWidth: "310px",
      width: "100%",
      boxSizing: "border-box",
      gridTemplateColumns: "50px 1fr",
      gridTemplateRows: "1fr",
      display: "grid",
      marginBottom: "20px",
    }}>

      <div style={{gridArea: "1/1/2/2", backgroundColor: colors.greyPrimary, display: "flex", justifyContent: "center", alignItems: "center"}}>
        <div style={{marginLeft: "-5px"}}><glyphs.AnimalGroup size="35px"/></div>
      </div>

      <div style={{
        gridArea: "1/2/2/3", 
        backgroundColor: colors.greyLightTertiary, 
        borderRadius: "0px 5px 5px 0px", 
        display: "grid",       
        gridTemplateColumns: "100px 1fr",
        gridTemplateRows: "1fr",
        padding: "10px",
        gap: "10px",
        boxSizing: "border-box"
        }}>
        <div style={{gridArea: "1/1/2/2", ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary, borderRight: "2px solid"+colors.greyTertiary, display: "flex", justifyContent: "start", alignItems: "center"}}>{t("animalPages.animalGroups.group")} {groupName}</div>
        <div style={{gridArea: "1/2/2/3", ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary, display: "flex", justifyContent: "start", alignItems: "center"}}>{t("animalPages.animalGroups.animalId")}: {groupAmount}</div>
      </div>

    </div>
  </> )
}